<script lang="ts" setup>
import { defineProps } from "vue";
import { useI18n } from "vue-i18n";
import { setLocale, type SupportedLocale } from "@/i18n";

defineProps({
  isVisible: {
    type: Boolean,
    default: true,
  },
});

const { locale } = useI18n();

const localeOptions: { label: string; value: SupportedLocale }[] = [
  { label: "RU", value: "ru" },
  { label: "EN", value: "en" },
];

const changeLocale = (nextLocale: SupportedLocale) => {
  setLocale(nextLocale);
};
</script>

<template>
  <div v-if="isVisible" class="language-switcher">
    <button
      v-for="item in localeOptions"
      :key="item.value"
      type="button"
      class="language-switcher__button caption-small--bold"
      :class="{ active: locale === item.value }"
      @click="changeLocale(item.value)"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/main";

.language-switcher {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 20;
  display: flex;
  gap: 8px;

  @media (max-width: 650px) {
    top: 16px;
    right: 16px;
  }

  &__button {
    width: auto;
    margin: 0;
    padding: 8px 14px;
    border-radius: 999px;
    border: 1px solid rgba(46, 48, 102, 0.15);
    background: rgba(255, 255, 255, 0.88);
    color: $purple;
    cursor: pointer;
    backdrop-filter: blur(10px);
    transition: all 0.2s ease;

    &.active {
      background: $purple;
      color: $white;
      border-color: $purple;
    }
  }
}
</style>
